import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./sites/home/HomePage";
import HereWeAre101Page from "./sites/hereweare101/HereWeAre101Page";
import MapLivePage from "./sites/mapLive/MapLivePage";
import ProfilePage from "./sites/profile/ProfilePage";
import InstallRedirectPage from "./sites/qr/InstallRedirectPage";
import QrRedirectPage from "./sites/qr/QrRedirectPage";
import VoicesPage from "./sites/voices/VoicesPage";

const routes = [
  { path: "/", element: <HomePage /> },
  { path: "/profile/:id", element: <ProfilePage /> },
  { path: "/qr", element: <QrRedirectPage /> },
  { path: "/qr/:qrId", element: <QrRedirectPage /> },
  { path: "/ssaf2026", element: <QrRedirectPage fixedQrId="ssaf-2026" /> },
  {
    path: "/herewearetheatreclub",
    element: <QrRedirectPage fixedQrId="htc-4" />,
  },
  {
    path: "/htc-onboarding",
    element: <QrRedirectPage fixedQrId="htc-onboarding" />,
  },
  { path: "/install", element: <InstallRedirectPage /> },
  { path: "/voices", element: <VoicesPage /> },
  { path: "/hereweare101", element: <HereWeAre101Page /> },
  { path: "/web/mapLive/maplive.html", element: <MapLivePage /> },
];

const RouterList = () => {
  return (
    <Routes>
      {routes.map((route) => (
        <Route key={route.path} path={route.path} element={route.element} />
      ))}

      {/* 정의되지 않은 경로 접근 시 리다이렉트 */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default RouterList;
